export default {
  /**
   * @description 节流
   * @param {*} fn 执行函数
   * @param {*} delay 节流时间,毫秒
   */
  throttl: (fn, delay) => {
    let timer = null
    return function() {
      if (!timer) {
        timer = setTimeout(() => {
          fn.apply(this, arguments)
          // 或者直接 fn()
          timer = null
        }, delay)
      }
    }
  },

  /**
   * @description 防抖
   * @param {*} fn 执行函数
   * @param {*} wait 防抖时间,毫秒
   */
  debounce: (fn, wait) => {
    let timeout = null
    return function() {
      if (timeout !== null) clearTimeout(timeout) // 如果多次触发将上次记录延迟清除掉
      timeout = setTimeout(() => {
        fn.apply(this, arguments)
        // 或者直接 fn()
        timeout = null
      }, wait)
    }
  },
}
